import { render } from "./png-icon.svg?vue&type=template&id=19a42e27"
import script from "./png-icon.svg?vue&type=script&lang=js"
export * from "./png-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3637/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__